import React from 'react';
import PropTypes from 'prop-types';
import { ValidatedLegacyCallToAction } from '@bingads-webui-campaign-react/legacy-call-to-action';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';

const getStyles = () => ({
  container: {
    height: '100%',
    '& #language-cta-boost': {
      position: 'relative',
      marginBottom: '10px',
    },
    '& #cta-boost': {
      position: 'relative',
      marginBottom: '10px',
    },
  },
});

export const ValidatedCallToAction = ({
  data,
  ...rest
}) => {
  const classes = useDefaultStyles(getStyles);

  const {
    languageValue,
    value,
    ctaText,
    ctaAriaText,
  } = data;

  return (
    <div className={classes.container}>
      <ValidatedLegacyCallToAction
        isBoostScenario
        isBoostCustomCTAEnabled
        id="cta-boost"
        languageValue={languageValue}
        value={value}
        ctaText={ctaText}
        ctaAriaText={ctaAriaText}
        {...rest}
      />
    </div>
  );
};

ValidatedCallToAction.propTypes = {
  data: PropTypes.shape({
    languageValue: PropTypes.string,
    value: PropTypes.string,
    ctaText: PropTypes.string,
    ctaAriaText: PropTypes.string,
  }).isRequired,
};

